import React, { useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../../../../../context/StateContext";
import { handleGetConvertValue } from "../../../../../../../../util/converts";
import { getMeasurement } from "../../../../../../../../util/getMeasurement";
import { Header } from "./components/Header";
import { List } from "./components/List";
import AssignModal, { AssignModalHandle } from "./components/Modal";
import { TypeModal } from "./enum";

export default function InventoryTab() {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();
  const assignModalRef = useRef<AssignModalHandle>(null);

  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  const data = [
    {
      id: 167472,
      valid: true,
      description: "table",
      descriptive: null,
      comments: "comment",
      status: "Registered",
      subStatus: "Actual",
      volume: 25,
      weight: 5,
      number: 1,
      quantity: 1,
      materials: null,
      mode: "Sea",
      damaged: false,
      qtyCheck: 0,
      qtyVoid: 0,
      leftPacked: true,
      wasBol: false,
      delivered: false,
      commentsDamaged: null,
      pickupFromDescription: null,
      packer: null,
      descriptiveSymbolId: 1884,
      companyId: 168,
      jobId: 15523,
      itemId: 8515,
      roomId: 1085,
      itemTypeId: 358,
      destinationResidenceId: null,
      destinationId: null,
      modeDestinationId: null,
      createdAt: "2023-05-12T11:50:03.000Z",
      updatedAt: "2023-05-12T11:50:03.000Z",
      uuid: "4fc7f996-4b09-43fa-8ff5-adf615ddbf66",
      itemType: {
        id: 358,
        valid: true,
        name: "Box",
        status: "Active",
        volume: 5,
        createdAt: "2022-08-23T12:18:07.000Z",
        updatedAt: "2022-08-23T12:18:07.000Z",
        companyId: 168,
      },
      room: {
        id: 1085,
        valid: true,
        name: "Bedroom",
        origin: null,
        code: "001",
        status: "Active",
        typeMobile: false,
        companyId: 168,
        createdAt: "2022-08-23T12:16:17.000Z",
        updatedAt: "2022-08-23T12:17:25.000Z",
        jobId: null,
      },
      symbol: {
        id: 1884,
        valid: true,
        name: "Method",
        prefix: "MP1",
        status: "Active",
        type: "Descriptive",
        property: false,
        createdAt: "2022-11-02T21:00:40.000Z",
        updatedAt: "2022-11-02T21:00:40.000Z",
        companyId: 168,
      },
      exceptions: [],
      pictures: [],
    },
  ];

  const getValue = (attribute: string, returnValue?: string) => {
    const value = data
      .map((item) => item[attribute as keyof typeof item] ?? 0)
      .reduce((total, next) => Number(total) + Number(next), 0);

    if (returnValue === "number") return Number(value);

    return String(value);
  };

  return (
    <React.Fragment>
      <Header.Root>
        <Header.Content text={translate("inventory") || ""} />
        <Header.Cards>
          <Header.Card title={translate("totalQty")} description={getValue("quantity") as string} />
          <Header.Card
            title={translate("volume")}
            description={`${handleGetConvertValue(
              getValue("volume", "number") as number,
              getMeasurement()?.code,
              getMeasurement()?.decimalPlaces
            )} ${getMeasurement()?.code}`}
          />
          <Header.Card
            title={translate("weight")}
            description={`${getValue("weight")} ${currentUser?.measurementWeight?.code}`}
          />
          <Header.Action
            disabled={selectedItems.length === 0}
            onSelect={(type) => {
              const title =
                type === TypeModal.LOCATION
                  ? translate("assignLocation")
                  : translate("assignStorageBoxLocation");

              assignModalRef?.current?.setOpenModalHandle(title, type);
            }}
          />
        </Header.Cards>
      </Header.Root>

      <List.Root>
        <List.Grid data={data} selects={selectedItems} setSelects={setSelectedItems} />
      </List.Root>

      <AssignModal ref={assignModalRef} />
    </React.Fragment>
  );
}
